<div class="container-fluid">
  <div class="mb-4 row">
    <div class="col">
      <h1>Service Charges</h1>
    </div>
    <div class="col add-service-charge">
      <button class="btn btn-primary" (click)="openModal()">
        Add Service Charge
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <table class="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (charge of serviceCharges; track charge.id) {
            <tr>
              <td>{{ charge.id }}</td>
              <td>{{ charge.name }}</td>
              <td>
                {{ getDescription(charge) }}
              </td>
              <td class="actions-container">
                <button
                  class="default-2 red"
                  (click)="deleteServiceCharge(charge)">
                  Delete
                </button>
                <button class="default-3" (click)="openModal(charge)">
                  <i class="ti ti-pencil"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
